module.exports = __webpack_public_path__ + "img/content1.9ff116b6.png";